import { CloudProviderWorker } from "./CloudProviderWorker";
import { Instance } from "../lib/kotenna/Instance";
import { CloudProvider } from "../lib/kotenna/CloudProvider";
import { VHost } from "../lib/kotenna/VHost";
import { inject, injectable } from "inversify";
import * as rp from "request-promise";
import { ConsoleUI } from "../utils/ConsoleUI";
import TYPES from "../TYPES";
import { KotennaApi } from "../lib/kotenna/KotennaApi";

export interface DigitalOceanCloudProvider extends CloudProvider {
    credential: string;
}

@injectable()
export class DigitalOceanWorker implements CloudProviderWorker {

    private console: ConsoleUI;
    private  api: KotennaApi;

    constructor( @inject(TYPES.ConsoleUI) ui: ConsoleUI, @inject(TYPES.KotennaApi) api: KotennaApi ) {
        this.console = ui;
        this.api = api;
    }

    async createProvider(): Promise<CloudProvider> {
        const name = await this.console.promptInput("Name for this provider?");
        const credential = await this.console.promptInput("API token - https://cloud.digitalocean.com/settings/api/tokens");

        this.console.loaderStart(`Validating credentials`);
        const me = await this.api.login();

        this.console.log(me);

        return rp({
            method: 'GET',
            uri: 'https://api.digitalocean.com/v2/account',
            json: true,
            auth: { 'bearer': credential }
        })
        .then(res => {
            if(res.account.status === 'active') {
                this.console.loaderSuccess("Credentials validated");

                return this.api.providerSave({
                    api: 'digitalocean',
                    credential,
                    name,
                    owner: me,
                });
            }
            else {
                throw new Error('The profile is not active!');
            }

        });
    }

    async createVhost(hostname: string, instance: Instance, provider: DigitalOceanCloudProvider, tpl: any): Promise<VHost> {

        // SSH keys can't be retrieved when the tpl is generated by /instance.
        // Get the list, and ask the user if he wants to attach tthem
        this.console.loaderStart(`Loading custom SSH keys`);
        const keys = await rp({
            uri: `https://api.digitalocean.com/v2/account/keys`,
            auth: { 'bearer': provider.credential },
            json: true
        });

        const choices = keys.ssh_keys.map(key => { return { name: key.name, value: key.id }; });
        const sshKeys = await this.console.promptCheckbox('Choose SSH keys to add to the droplet', choices);

        tpl.ssh_keys = sshKeys;

        // Edit: today is 01/11/2018, 21:02. I'm re-writing the cli, probably not a good idea...
        // Its 25/08/2018, 03:34 am. Nina Simone is singing "My Baby Just Cares For Me".
        return Promise.resolve(new VHost({
            hostname,
            node_name: instance.name,
            provider_api: provider.api,
            provider_key: provider.name,
            tpl
        }));


    }

}